<template>
  <div class="modal-helper" @click.stop="closeModal">
    <div class="modal-helper__wrapper" @click.stop>
      <section class="modal-helper__content">
        <header class="modal-helper__header">
          <button
            class="modal-helper__close-button"
            @click.stop.prevent="closeModal"
          >
            <img src="~~/assets/icons/cross.svg" alt="cross" />
          </button>
        </header>
        <main class="modal-helper__main">
          <div class="modal-helper__image-wrapper">
            <svg
              width="54"
              height="54"
              viewBox="0 0 54 54"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M27 25.875L27 37.125"
                stroke="#F36C21"
                stroke-width="3.375"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M27 16.8975L27.0225 16.8725"
                stroke="#F36C21"
                stroke-width="3.375"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M27 49.5C39.4264 49.5 49.5 39.4264 49.5 27C49.5 14.5736 39.4264 4.5 27 4.5C14.5736 4.5 4.5 14.5736 4.5 27C4.5 39.4264 14.5736 49.5 27 49.5Z"
                stroke="#F36C21"
                stroke-width="3.375"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <p class="modal-helper__description">
            <slot />
          </p>
        </main>
      </section>
    </div>
  </div>
</template>

<script setup>
const emits = defineEmits(["close"]);

function closeModal() {
  emits("close");
  document.documentElement.style.overflow = "auto";
}
</script>

<style lang="scss" scoped>
.modal-helper {
  display: none;

  position: fixed;
  @include setAbs(0, 0, 0, 0);
  z-index: 2;

  background-color: rgb(0, 0, 0, 0.5);

  @include bigMobile {
    &.active {
      display: flex;
    }
  }

  &__wrapper {
    max-width: 345px;
    width: 100%;

    margin: auto;
    padding: 12px 16px 32px 16px;

    border-radius: 8px;

    background-color: white;
  }

  &__header {
    @include flex-container(row, flex-end);

    margin-bottom: 8px;
  }

  &__close-button {
    @include fixedHW(32px, 32px);

    @include flex-container(row, center, center);

    & img {
      @include fixedHW(14px, 14px);
    }
  }

  &__main {
    @include flex-container(column, center, center);
    row-gap: 28px;
  }

  &__image-wrapper {
    font-size: 0;
  }

  &__description {
    @include font(16, 22);
    letter-spacing: 0.02em;
    color: #2b2b2b;
  }
}
</style>
